import { NetworkIds } from '~config/rpcConfig';
import { ENativeAsset, EVestaAsset } from '~config/types';

import { getContractAddress } from '..';
import { EContractName } from '../contractConfig';

import { ConfigCollateral } from './types';

export const COLLATERAL_CONFIG: { [index in EVestaAsset]: ConfigCollateral } = {
  [EVestaAsset.ETH]: {
    isVaultRewarded: false,
    stabilityPoolReward: ENativeAsset.VSTA,
    getStabilityPoolAddress: (networkId: NetworkIds) =>
      getContractAddress(EContractName.ETHStabilityPool, networkId),
  },
  [EVestaAsset.gOHM]: {
    isVaultRewarded: true,
    stabilityPoolReward: ENativeAsset.VSTA,
    getStabilityPoolAddress: (networkId: NetworkIds) =>
      getContractAddress(EContractName.gOHMStabilityPool, networkId),
  },
  [EVestaAsset.renBTC]: {
    disabled: true,
    isVaultRewarded: false,
    stabilityPoolReward: ENativeAsset.VSTA,
    getStabilityPoolAddress: (networkId: NetworkIds) =>
      getContractAddress(EContractName.renBTCStabilityPool, networkId),
  },
  [EVestaAsset.DPX]: {
    isVaultRewarded: false,
    stabilityPoolReward: EVestaAsset.DPX,
    getStabilityPoolAddress: (networkId: NetworkIds) =>
      getContractAddress(EContractName.DPXStabilityPool, networkId),
  },
  [EVestaAsset.GMX]: {
    isVaultRewarded: true,
    stabilityPoolReward: EVestaAsset.GMX,
    getStabilityPoolAddress: (networkId: NetworkIds) =>
      getContractAddress(EContractName.GMXStabilityPool, networkId),
  },
  [EVestaAsset.sGLP]: {
    isVaultRewarded: true,
    stabilityPoolReward: EVestaAsset.GMX,
    getStabilityPoolAddress: (networkId: NetworkIds) =>
      getContractAddress(EContractName.GLPStabilityPool, networkId),
  },
  [EVestaAsset.ARB]: {
    isVaultRewarded: false,
    stabilityPoolReward: ENativeAsset.VSTA,
    getStabilityPoolAddress: (networkId: NetworkIds) =>
      getContractAddress(EContractName.ARBStabilityPool, networkId),
  },
  [EVestaAsset.wstETH]: {
    isVaultRewarded: false,
    stabilityPoolReward: ENativeAsset.VSTA,
    getStabilityPoolAddress: (networkId: NetworkIds) =>
      getContractAddress(EContractName.wstETHStabilityPool, networkId),
  },
};
